import { cx } from "../utils/format";

/** A small rotating ring for a short wait (the founder, 2026-10-12: the repository dialog shows it while it reads the repositories). It is
 *  announced as a status with its label as the accessible name; it stands still for people who ask for reduced motion (the stylesheet).
 *  `decorative` (integrations round two, 2026-10-13): hidden from screen readers, for a spinner inside something that already says it is
 *  busy (the busy Button carries `aria-busy`, and its name stays its label). */
export function Spinner({ label = "Loading", decorative, className }: { label?: string; decorative?: boolean; className?: string }) {
  if (decorative) return <span className={cx("ob-spinner", className)} aria-hidden="true" />;
  return <span className={cx("ob-spinner", className)} role="status" aria-label={label} />;
}
